import PageMeta from '@/modules/component/PageMeta';
import { registerLocaleResources, useTranslation } from '@/modules/i18n/useTranslation';

import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';

registerLocaleResources('Error404Page', { en, es, ru });

declare module '@/modules/i18n/namespaces' {
    interface LocaleNamespaces {
        Error404Page: typeof en;
    }
}

const Error404Page = () => {
    const { t } = useTranslation('Error404Page');
    return (
        <div>
            {/* No page answers this URL, so it has no twins in other languages */}
            <PageMeta title={t('title')} alternates={false}/>
            <span>{t('notFound')}</span>
        </div>
    );
};

export default Error404Page;
